import { Detailed, useGLTF } from '@react-three/drei';
import { limitThreeVal } from 'constant/env';

type Props = {
  pos?: Array<number>;
  value?: number;
};

export default function ApartOne({
  pos = [0.4, 0.5, -0.36],
  value = 2000000,
}: Props) {
  const { scene: floor } = useGLTF('assets/model/floor4.glb');
  const { scene: mediumFloor } = useGLTF('assets/model/medium_floor4.glb');
  const { scene: roof } = useGLTF('assets/model/roof1.glb');
  return (
    <group position={[pos[0], pos[1], pos[2]]} scale={[0.3, 0.3, 0.3]}>
      <Detailed distances={window.innerWidth > 1024 ? [0, 20] : [0, 10]}>
        <group>
          <primitive object={floor.clone()} />
          {Array(Math.floor(value / limitThreeVal))
            .fill(null)
            .map((_, i) => (
              <primitive
                object={mediumFloor.clone()}
                position={[0, 1.15 * (i + 1), 0]}
                key={i}
              />
            ))}
          <primitive
            object={roof.clone()}
            position={[0, (Math.floor(value / limitThreeVal) + 1) * 1.15, 0]}
          />
        </group>
        <group scale={[1, (Math.floor(value / limitThreeVal) + 1) * 1.15, 1]}>
          <mesh position={[1, 0.5, -1]}>
            <boxBufferGeometry args={[2, 1, 2]} />
            <meshBasicMaterial color={'grey'} />
          </mesh>
        </group>
      </Detailed>
    </group>
  );
}
